/**
 * This file was auto-generated by @gonfalon/openapi/generate.ts.
 * Do not make direct changes to the file.
 *
 * If you have any questions, reach out to #ask-frontend.
 */

import { mergeHeaders } from 'openapi-fetch';

import { getClient } from '../../internal/client';
import type { operations } from '../openapi';

import * as overrides from '../../operation-overrides/getViewsOverrides';
import type { GetViewsQueryParams } from '../../operation-overrides/getViewsOverrides';

export type GetViewsPathParams = NonNullable<operations['getViews']['parameters']['path']>;
export type { GetViewsQueryParams };

export interface Input extends GetViewsPathParams {
  apiVersion?: string;
  query?: GetViewsQueryParams;
  header: NonNullable<operations['getViews']['parameters']['header']>;
}

export async function getViews(
  { apiVersion, query, header, ...path }: Input,
  { headers, signal }: { headers?: HeadersInit; signal?: AbortSignal } = {},
) {
  return getClient().GET('/api/v2/projects/{projectKey}/views', {
    params: {
      path,
      // @ts-ignore We explicitly ignore errors here because we know the types may not match the spec
      query,
      header,
    },
    // @ts-ignore We explicitly ignore errors here because we know the types may not match the spec
    querySerializer: overrides.querySerializer,
    headers: apiVersion ? mergeHeaders(headers, { 'LD-API-Version': apiVersion }) : headers,
    signal,
  });
}
